import React, { useCallback } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card } from '@factorialco/f0-react'

import { ElementPreview } from 'modules/forms/components/preview/ElementPreview'
import { Element } from 'modules/forms/lib/Element'
import { Form } from 'modules/forms/lib/Form'
import { SectionElement } from 'modules/forms/lib/elements/SectionElement'
import { Answer } from 'modules/forms/lib/types'

interface FormRenderProps {
  form: Form
  onFormUpdated?: () => void
}

const FormAnswerInline: React.FC<FormRenderProps> = ({ form, onFormUpdated }) => {
  const handleAnswer = useCallback(
    (answer: Answer, elementId: string) => {
      const element = form?.getElement(elementId)
      if (element) element.answer = answer
      onFormUpdated?.()
    },
    [form, onFormUpdated]
  )
  return (
    <Box gap="s24">
      {form.elements.map((element: Element) => {
        if (element instanceof SectionElement) {
          return (
            <Box key={element.uuid} gap="s8">
              <Box gap="s8">
                <Text size="300" weight="bold" color="textPrimary">
                  {element.label}
                </Text>
                {element.description && (
                  <Text size="200" color="textSecondary">
                    {element.description}
                  </Text>
                )}
              </Box>

              <Box gap="s8">
                {element.elements.map((child: Element) => (
                  <F0Card key={child.uuid}>
                    <Box style={{ pointerEvents: 'auto' }}>
                      <ElementPreview
                        element={child}
                        mode="answer"
                        handleAnswer={handleAnswer}
                        titleSize="small"
                      />
                    </Box>
                  </F0Card>
                ))}
              </Box>
            </Box>
          )
        }

        return (
          <F0Card key={element.uuid}>
            <Box style={{ pointerEvents: 'auto' }}>
              <ElementPreview
                element={element}
                mode="answer"
                handleAnswer={handleAnswer}
                titleSize="small"
              />
            </Box>
          </F0Card>
        )
      })}
    </Box>
  )
}

/**
 * @public
 *
 * TODO: Remove once FormAnswerInline is used anywhere
 * */
export default FormAnswerInline
